"use client";const a=/([0-9]+|([A-Z][a-z]+)|[a-z]+|([A-Z]+)(?![a-z]))/g,t=t=>(String(null!=t?t:"").match(a)||[]).map((a=>a.toLowerCase())).join("-");export{t as default};
